<p-autoComplete
  #placeAutocomplete
  [(ngModel)]="selectedValue"
  [suggestions]="searchPlaceResults"
  [showEmptyMessage]="!isResolvingGoogleMapsUrl"
  (completeMethod)="searchPlaces($event)"
  (onSelect)="onSelect($event)"
  [minLength]="1"
  [forceSelection]="true"
  [autoHighlight]="true"
  optionLabel="name"
  styleClass="w-full"
  (onBlur)="onTouched()"
></p-autoComplete>
